import { NextPageContext } from 'next'

import { serverSidePropsFor } from '@/utils/helpers'

import CommanderPage from '../commanders'

const IndividualCardPage = (props: any) => <CommanderPage {...props} />

export const getServerSideProps = async ({ query: { slug } }: NextPageContext) => {
  const replacedSlug = slug === 'boomerang' ? 'boomerang_' : slug // Adblock workaround
  return serverSidePropsFor(`https://json.edhrec.com/pages/cards/${replacedSlug}.json`)()
}

export default IndividualCardPage
